import { isObject } from 'util';

import { Inject } from '@odinjs/odin';

import { APPLICATION_ROUTES, Endpoint, ToastServiceStipulator } from '@philips-emr/hpms-stipulator-commons';
import { FetchAPI, FieldAPI, FormAPI, ToastNotificationAPI } from '@philips-emr/tws-components';
import { Value } from '@philips-emr/tws-core';
import Controller, { OnAfterFetch, OnBeforeSubmit, OnCancel, OnClose, OnMount } from '@philips-emr/tws-core/lib/client';
import { AbortableSubmitEvent, FetchEvent, MountEvent } from '@philips-emr/tws-core/lib/component/types';
import { HistoryService, HttpService, msg } from '@philips-emr/tws-core/lib/services';
import { isContentfulString, isEmptyObject } from '@philips-emr/tws-utils';

import BaseController from './BaseController';

interface Retorno {
  dsLocalizacao: string;
}

@Controller({ fragment: 'alterar-localizacao' })
class AlterarLocalizacaoController extends BaseController {

  @Inject('field-atual')
  private fieldAtual: FieldAPI;
  @Inject('form-alterar-localizacao')
  private formDados: FormAPI;
  @Inject('toast-notification')
  private toastForm: ToastNotificationAPI;
  @Inject('fetch-atual')
  private fetchAtual: FetchAPI;

  @OnMount({ target: 'form-alterar-localizacao' })
  onMountForm(event: MountEvent): void {
    const apiForm = event.target as unknown as FormAPI;
    const { nrSeqBeneficiario, nrSeqContrato } = HistoryService.getCurrentRouteParams();

    void HttpService.get<Record<string, Value>>(Endpoint.GET.SOLIC_ALT_LOCALIZACAO_ABERTA, { nrSeqBeneficiario, nrSeqContrato })
      .then(response => {

        const { body: solicAberta } = response;

        if (!solicAberta) {
          this.executaConsultaLocalizacaoAtual();
          return;
        }

        const { nrSeqSolicAlt, dsLocalizacao } = solicAberta;
        this.context.set({ nrSeqSolicAlt });
        apiForm.setData(solicAberta);

        if (!dsLocalizacao) {
          this.fieldAtual.setData({ dsLocalizacao: '-' });
        }

      }).catch(() => {
        this.executaConsultaLocalizacaoAtual();
      });
  }

  @OnAfterFetch({ target: 'fetch-atual' })
  OnAfterFetch(event: FetchEvent): void {
    if (!event.data) {
      return;
    }
    const data = event.data as Retorno;
    const { dsLocalizacao } = data;

    if (!dsLocalizacao) {
      this.fieldAtual.setData({ dsLocalizacao: '-' });
    }
  }

  @OnBeforeSubmit({ target: 'form-alterar-localizacao' })
  onBeforeSubmit(event: AbortableSubmitEvent): void {
    const dados = this.formDados.getRecord();
    const { nrSeqBeneficiario, nrSeqGrupoContratoWeb, nrSeqContrato } = HistoryService.getCurrentRouteParams();
    const { nrSeqSolicAlt } = this.context.getBulkData();
    const body = { ...dados, nrSeqSolicAlt };

    HttpService.post(Endpoint.POST.SOLIC_ALT_LOCALIZACAO, { nrSeqBeneficiario, nrSeqContrato }, { body })
      .then(() => {
        ToastServiceStipulator.success(msg('stipuplator.alteracao.solicitada'));
        HistoryService.push(APPLICATION_ROUTES.ALTERACAO_BENEFICIARIO, { nrSeqGrupoContratoWeb, nrSeqContrato });
      }).catch(response => {
        this.formDados.setEditing(true);

        const openToast = (msg: string): void => {
          this.toastForm.setMessage(msg);
          this.toastForm.setVisible(true);
        };

        const { body } = response;

        if (isObject(body) && !isEmptyObject(body)) {
          return openToast(body[Object.keys(body)[0]]);
        }

        if (isContentfulString(body)) {
          return openToast(body);
        }

        event.abort();
      });
  }

  @OnCancel({ target: 'form-alterar-localizacao' })
  onCancelForm(): void {
    const { nrSeqGrupoContratoWeb, nrSeqContrato } = HistoryService.getCurrentRouteParams();
    HistoryService.push(APPLICATION_ROUTES.ALTERACAO_BENEFICIARIO, { nrSeqGrupoContratoWeb, nrSeqContrato });
  }

  @OnClose({ target: 'toast-notification' })
  onCloseToast(): void {
    this.toastForm.setVisible(false);
  }

  private executaConsultaLocalizacaoAtual(): void {
    const { nrSeqBeneficiario } = HistoryService.getCurrentRouteParams();
    this.context.set({ nrSeqBeneficiario });
    this.fetchAtual.forceFetch();
  }

}

export default AlterarLocalizacaoController;
